<template>
    <b-card>
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name"
                    label-for="input-name"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        required
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>
                <b-button
                    variant="secondary"
                    :disabled="loading ? true : false"
                    @click="cancel()"
                    >Cancel</b-button
                >
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="loading ? true : false"
                    >{{ submitLabel }}</b-button
                >
                <b-button
                    v-if="model.id"
                    @click="deleteAssetType()"
                    variant="warning"
                >
                    Delete Asset Type
                </b-button>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'view-item',
    data() {
        return {
            title: 'Asset Type',
            loading: false,
            model: {
                id: 0,
                name: null,
                description: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        systemTypes() {
            return this.$store.state.orderType.systemTypes.map(x => ({
                value: x,
                text: x,
            }))
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id ? 'assets/updateType' : 'assets/createType'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? 'Updated' : 'Created'
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteAssetType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'assets/deleteType'

            // Generate and display confirmation prompt
            const title = 'Delete Asset Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Asset Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
